/**
 * @file IntervalField.tsx
 * @description «Сменять каждые» у полосы объявлений числом (phase19.16,
 * партия SB120, этап 3б; uiux-sb120-stage3 §3 «Объявления»; данные
 * db-design-sb120-stage3 §1 `announcements.intervalSec`): целые 2–30 с,
 * подсказки [3][6][10], «↺ 6». Быстрее 5 с —
 * предупреждение shared под полем («Объявление не успеют дочитать»), не
 * запрет; shared проверяет только полосу, где есть что сменять (два и
 * больше объявлений), поэтому под полем «При одном объявлении смены нет».
 * Значение обязательное: «↺» пишет 6.
 */

import { SECTION_LOOK_LIMITS } from "@chaiberi/shared";

import { NumberSliderField } from "../../../site-fields/NumberSliderField";
import { ElementWarningNote } from "../fields/ElementWarningNote";
import { useSectionForm } from "../section-form-context";
import { ownValue } from "../../../../lib/site-fields/number-input";

const I = SECTION_LOOK_LIMITS.intervalSec;
const INTERVAL_HINT = "При одном объявлении смены нет.";

/** Подсказки: быстро / как обычно / спокойно. */
const HINTS = [3, 6, 10] as const;

interface Props {
  value: number;
  onChange: (sec: number) => void;
  /** Путь элемента — предпросмотр и предупреждение `…intervalSec`. */
  path: string;
}

export function IntervalField({ value, onChange, path }: Props) {
  const { preview } = useSectionForm();
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <NumberSliderField
        label="Сменять каждые"
        integer
        value={ownValue(value, I.default)}
        inherit={{ value: I.default, label: `${I.default} с` }}
        min={I.min}
        max={I.max}
        step={1}
        unit="s"
        presets={HINTS.map((n) => ({ label: String(n), value: n }))}
        hint={INTERVAL_HINT}
        onChange={(v) => onChange(v ?? I.default)}
        onPreview={(v) => preview(`${path}.intervalSec`, v ?? I.default)}
      />
      <ElementWarningNote path={`${path}.intervalSec`} />
    </div>
  );
}
